import './Button.scss'

export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  loading = false,
  icon,
  iconRight,
  onClick,
  type = 'button',
  className = '',
  ...props
}) => {
  const classes = [
    'tb-btn',
    `tb-btn--${variant}`,
    `tb-btn--${size}`,
    fullWidth && 'tb-btn--full',
    loading && 'tb-btn--loading',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
      {...props}
    >
      {loading && <span className="tb-btn__spinner" />}
      {!loading && icon && <span className="tb-btn__icon">{icon}</span>}
      {children && <span className="tb-btn__text">{children}</span>}
      {!loading && iconRight && (
        <span className="tb-btn__icon-right">{iconRight}</span>
      )}
    </button>
  )
}
